import React, { useContext, useEffect, useState } from "react";
import closeSvg from "../../../../assets/closeSvg";
import { TransferToMoveContext } from "./TransferToMoveContext";
import { AppContext } from "../../../../AppContext";
import TransferClientModal from "./TransferClientModal/TransferClientModal";
import { TransferClientContext } from "./TransferClientModal/TransferClientContext";
import { logActivity } from "../../../utils";

const TransferToMove = ({
  formId,
  presetListOfClients = null,
  transferDescription = "Transfer leads from your FUB account.",
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [fubListTransferToMove, setFubListTransferToMove] = useState([]);
  const [selectedClient, setSelectedClient] = useState();
  const [transferClientVisible, setTransferClientVisible] = useState(false);
  const [loadingList, setLoadingList] = useState(`Loading results from FUB...`);
  const [stopOverflowY, setStopOverflowY] = useState(false);
  const [transferFilter, setTransferFilter] = useState(false);
  const [zhlInterestedFilter, setZhlInterestedFilter] = useState(false);
  const [nextLink, setNextLink] = useState("");

  const {
    fubId,
    fubKey,
    makeKey,
    userEmail,
    userType,
    userCompany,
    teamMemberSelected,
  } = useContext(AppContext);

  const {
    transferToMoveVisible,
    setTransferToMoveVisible,
    zindex = "one",
    successFunctions,
  } = useContext(TransferToMoveContext);

  let listOfClients = [];
  if (fubListTransferToMove.length === 0) {
    listOfClients = (
      <div className="ClientRow grey">
        <div className="subtext">{loadingList}</div>
      </div>
    );
  } else {
    listOfClients = fubListTransferToMove
      .filter((client) => {
        if (transferFilter) {
          const moveTransferred = client.tags.includes("Move Transferred");
          return !moveTransferred;
        } else if (zhlInterestedFilter) {
          const zhlInterested = client.tags.includes("ZHL Interested");
          return zhlInterested;
        }
        return client;
      })
      .map((client, index) => {
        const moveTransferred = client.tags.includes("Move Transferred");
        const zhlInterested = client.tags.includes("ZHL Interested");
        const zhlTransferred = client.tags.includes("ZHL Transferred");
        const addTag = moveTransferred || zhlInterested || zhlTransferred;

        const approvedForMove = client.tags.includes(
          "Approved for Move Transfer"
        );

        return (
          <div
            key={index}
            className={`ClientRow ${moveTransferred ? "grey" : null}`}
            onClick={() => {
              let addLastName = null;

              if (moveTransferred) {
                alert("Lead has already been transferred to Move");
              } else {
                let proceed = true;
                if (!client.lastName || client.lastName == "") {
                  addLastName = prompt(
                    `Client is missing last name in FUB. What is client's last name? If unsure, add TBD.`
                  );
                  if (addLastName) {
                    const options = {
                      method: "PUT",
                      headers: {
                        accept: "application/json",
                        "content-type": "application/json",
                        authorization: `Basic ${window.btoa(fubKey)}`,
                      },
                      body: JSON.stringify({ lastName: addLastName }),
                    };
                    fetch(
                      `https://api.followupboss.com/v1/people/${client.id}?mergeTags=true`,
                      options
                    ).then(() => {
                      logActivity({
                        apiKey: makeKey,
                        userEmail: userEmail,
                        userType: userType,
                        action: "Updated FUB Client's Last Name",
                        tab: "Modal",
                        userCompany: userCompany,
                      });
                    });
                  } else if (addLastName == "") {
                    alert(
                      "Last name was left blank. Please click the client again to add their last name and complete the transfer."
                    );
                    proceed = false;
                  } else {
                    proceed = false;
                  }
                }

                if (proceed) {
                  if (addLastName) {
                    client.lastName = addLastName;
                    setSelectedClient(client);
                  } else {
                    setSelectedClient(client);
                  }
                  setTransferClientVisible(true);
                  setStopOverflowY(true);
                }
              }
            }}
          >
            <div className="transfer name">{client.name}</div>
            {addTag ? (
              <div className="tag transferTag">
                {moveTransferred
                  ? "Move Transferred"
                  : zhlTransferred
                  ? "ZHL Transferred"
                  : zhlInterested
                  ? "ZHL Interested"
                  : null}
              </div>
            ) : null}
          </div>
        );
      });
    if (listOfClients.length === 0) {
      listOfClients = (
        <div className="ClientRow grey">
          <div className="subtext">{loadingList}</div>
        </div>
      );
    }
  }

  function runNextFetch() {
    setLoadingList("Loading results from FUB...");

    const options = {
      method: "GET",
      headers: {
        accept: "application/json",
        authorization: `Basic ${window.btoa(fubKey)}`,
      },
    };

    fetch(nextLink, options)
      .then((response) => response.json())
      .then((response) => {
        setNextLink(response["_metadata"]["nextLink"]);
        const names = response["people"].map((e) => {
          return {
            name: e.name,
            firstName: e.firstName,
            lastName: e.lastName,
            id: e.id,
            tags: e.tags,
            phones: e.phones,
            emails: e.emails,
            stage: e.stage,
          };
        });
        setFubListTransferToMove(names);
        if (names.length < 1) {
          setLoadingList("No leads match this search criteria.");
        } else if (fubId !== 0) {
          setLoadingList(
            `No leads to transfer. Email mike@movemortgage.com if this doesn't seem right.`
          );
        } else {
          setLoadingList(
            `Your FUB account is not synced with Matrix. Reach out to mike@movemortgage.com to connect your account!`
          );
        }
      })
      .catch((err) => console.error(err));
  }

  const [fubLink, setFubLink] = useState();

  useEffect(() => {
    if ( teamMemberSelected == "Move Admin" && userCompany == "Be1 Team") {
      setFubLink(
        `https://api.followupboss.com/v1/people?sort=name&limit=100&phone=${searchValue}&offset=0&includeTrash=false&includeUnclaimed=false`
        );
      } else {
        setFubLink(
        `https://api.followupboss.com/v1/people?sort=name&limit=100&name=${searchValue}&offset=0&assignedUserId=${fubId}&includeTrash=false&includeUnclaimed=false`
      );
    }
  }, [userCompany, teamMemberSelected, searchValue, fubId]);

  useEffect(() => {
    if (presetListOfClients) {
      setLoadingList("No leads match this search criteria.");
    }
    if (transferToMoveVisible && presetListOfClients) {
      setFubListTransferToMove(presetListOfClients);
    } else if (transferToMoveVisible && !presetListOfClients) {
      setLoadingList("Loading results from FUB...");

      const options = {
        method: "GET",
        headers: {
          accept: "application/json",
          authorization: `Basic ${window.btoa(fubKey)}`,
        },
      };

      fetch(fubLink, options)
        .then((response) => response.json())
        .then((response) => {
          setNextLink(response["_metadata"]["nextLink"]);
          const names = response["people"].map((e) => {
            return {
              name: e.name,
              firstName: e.firstName,
              lastName: e.lastName,
              id: e.id,
              tags: e.tags,
              phones: e.phones,
              emails: e.emails,
              stage: e.stage,
            };
          });
          setFubListTransferToMove(names);
          if (names.length < 1) {
            setLoadingList("No leads match this search criteria.");
          } else if (fubId !== 0) {
            setLoadingList(
              `No leads to transfer. Email mike@movemortgage.com if this doesn't seem right.`
            );
          } else {
            setLoadingList(
              `Your FUB account is not synced with Matrix. Reach out to mike@movemortgage.com to connect your account!`
            );
          }
        })
        .catch((err) => console.error(err));
    }
  }, [fubLink, transferToMoveVisible]);

  return (
    <div
      className={`ModalPage ${
        transferToMoveVisible ? "" : "hidden"
      } ${zindex} ${stopOverflowY ? "stopOverflowY" : ""}`}
    >
      <div className="Modal-background" onClick={()=>{setTransferToMoveVisible(false)}}></div>
      <div className="Modal-container">
        <form className="Modal">
          <div className="spaceBetween">
            <b>Transfer to Move</b>
            <div
              className="Modal-close"
              onClick={() => {
                setTransferToMoveVisible(false);
              }}
            >
              {closeSvg}
            </div>
          </div>
          <div>{transferDescription}</div>
          <div className="fivePx"></div>
          {presetListOfClients ? null : (
            <>
              {/* {(teamMemberSelected == "Move Admin" && userCompany == "Be1 Team"?null:<div className="spaceBetween">
                <input
                  className="searchInput"
                  placeholder="Search client name"
                  onChange={(e) => {
                    setSearchValue(e.target.value.toLowerCase());
                  }}
                ></input>
              </div>)} */}
              <div className="spaceBetween">
                <input
                  className="searchInput"
                  placeholder={(teamMemberSelected == "Move Admin" && userCompany == "Be1 Team"?"Search lead by phone":"Search client name")}
                  onChange={(e) => {
                    setSearchValue(e.target.value.toLowerCase());
                  }}
                ></input>
              </div>
              <div className="fivePx"></div>
              <div className="transfer-filters">
                {/* <div
                  className={`transfer filter-panel ${
                    transferFilter ? null : "noFilterText"
                  }`}
                  onClick={() => {
                    {
                      setZhlInterestedFilter(false);
                      transferFilter
                        ? setTransferFilter(false)
                        : setTransferFilter(true);
                    }
                  }}
                >
                  Transfer to Move
                </div>
                <div
                  className={`transfer filter-panel ${
                    zhlInterestedFilter ? null : "noFilterText"
                  }`}
                  onClick={() => {
                    {
                      setTransferFilter(false);
                      zhlInterestedFilter
                        ? setZhlInterestedFilter(false)
                        : setZhlInterestedFilter(true);
                    }
                  }}
                >
                  ZHL Interested
                </div> */}
              </div>
            </>
          )}
          {listOfClients}
          {nextLink && nextLink !== "" ? (
            <>
              <div className="tenPx"></div>
              <div
                className="blueLink"
                onClick={() => {
                  runNextFetch();
                }}
              >
                See More
              </div>
            </>
          ) : null}
        </form>
      </div>
      <TransferClientContext.Provider
        value={{
          selectedClient,
          setSelectedClient,
          transferClientVisible,
          setTransferClientVisible,
          setTransferToMoveVisible,
          setStopOverflowY,
          successFunctions,
          formId,
        }}
      >
        <TransferClientModal formId={formId} />
      </TransferClientContext.Provider>
    </div>
  );
};

export default TransferToMove;
